import { createFileRoute } from '@tanstack/react-router';
import { ItemPage, lerBuscaItemDetalhe } from '@/components/item-cadastro';

export const Route = createFileRoute('/_app/cadastros/itens/$id')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaItemDetalhe(bruto),
  component: ItemRota,
});

function ItemRota() {
  const { id } = Route.useParams();
  return <ItemPage key={id} id={id} busca={Route.useSearch()} />;
}
